import * as React from "react";
import { styled } from "@mui/material";
import clsx from "clsx";

//region [[ Styles ]]

const SettingSwitchView = styled("div")({
  display: "flex",
  position: "relative",
  width: "54px",
  height: "30px",
  background: "#BDBDBD",
  cursor: "pointer",
  borderRadius: "30px",
  "&.checked": {
    background: "#008A37",
  },
  "&.disabled": {
    background: "#00000022",
    cursor: "default",
  },
  // "&.disabled.checked": {
  //   background: "#006437",
  // },
});

const SwitchButton = styled("div")({
  position: "absolute",
  borderRadius: "50%",
  transition: "all 0.3s ease-out",
  background: "white",
  boxShadow: "0px 0px 13px rgba(0, 0, 0, 0.15)",
  left: "3px",
  right: "calc(100% - 27px)",
  width: "25px",
  height: "25px",
  top: "3px",
  cursor: "pointer",
  ".checked &": {
    right: "3px",
    left: "calc(100% - 27px)",
  },
  ".disabled &": {
    background: "#efefef",
    cursor: "default",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SettingSwitchProps {
  className?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    value: boolean,
  ) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SettingSwitch = ({ ...props }: SettingSwitchProps) => {
  return (
    <SettingSwitchView
      className={clsx(
        "setting-switch",
        props.checked ? "checked" : "",
        props.disabled ? "disabled" : "",
        props.className,
      )}
      onClick={(e) => {
        if (!props.disabled) props.onChange?.(e, !props.checked);
      }}
    >
      <SwitchButton
        onClick={(e) => {
          if (!props.disabled) props.onChange?.(e, !props.checked);
        }}
      />
    </SettingSwitchView>
  );
};
